// extracted by mini-css-extract-plugin
module.exports = {"item":"BlockContent_item__Na6lb"};